import * as React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { Lead } from './types';
import { Spinner } from '../assets/Spinner';
import { LeadDetail } from '../component/LeadDetail/LeadDetail';
import { NotFound } from '../component/NotFound';
import { useGetLeadTreatments } from '../hooks/getLeadTreatments';

const LeadProfileContent = ({ lead }: { lead: Lead }) => {
  const {
    treatments,
    isLoading: isLoadingTreatments,
    isError: treatmentsIsError,
  } = useGetLeadTreatments(lead.id);

  if (isLoadingTreatments) return <Spinner />;
  if (treatmentsIsError) return <NotFound />;

  return <LeadDetail lead={lead} treatments={treatments} />;
};

export const LeadProfile = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const lead = (state as { lead: Lead } | null)?.lead;
  const email = searchParams.get('email');

  useEffect(() => {
    if (lead || !email) return;
    navigate(`/lead-lookup?email=${encodeURIComponent(email)}`);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!lead && email) return <Spinner />;
  if (!lead) return <NotFound />;

  return (
    <div className="h-[calc(100vh-77px)] bg-slate50 p-8">
      <LeadProfileContent lead={lead} />
    </div>
  );
};
